/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainSettingsUnityOptions, FxIdDomainSettingsUnityOptionsFromJSONTyped, FxIdDomainSettingsUnityOptionsToJSON, } from './FxIdDomainSettingsUnityOptions';
export function FxIdDomainSettingsPublicWebClientConfigOptionsUnityFromJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsUnityFromJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsUnityFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsUnityOptions(json)) {
        return FxIdDomainSettingsUnityOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsUnityToJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsUnityToJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsUnityToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainSettingsUnityOptions(value)) {
        return FxIdDomainSettingsUnityOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdDomainSettingsPublicWebClientConfigOptionsUnity.js.map